export const formTypeFilesModalShow = (files) => {
  return {
    type: 'FORMTYPE_FILES_MODAL_SHOW',
    files,
  };
};

export const formTypeFilesModalHide = () => {
  return {
    type: 'FORMTYPE_FILES_MODAL_HIDE',
  };
};

export const formTypeAddModalShow = () => {
  return {
    type: 'FORMTYPE_ADD_MODAL_SHOW',
  };
};

export const formTypeAddModalHide = () => {
  return {
    type: 'FORMTYPE_ADD_MODAL_HIDE',
  };
};
